import LandingPage from './LandingPage';
import LandingPageHead from './LandingPageHead';

export { LandingPageHead, LandingPage };
